<template>
  <!-- Fake rich text editor -->
  <div v-if="!isFocus" class="lazy-rich-text-editor" @click="handleFocus">
    <wiris-rich-text :content="initialContent" />
  </div>
  <rich-text-editor
    v-else
    v-bind="{ initialContent, ...attrs }"
    :class="attrs.class"
    v-on="inputListeners"
  />
</template>

<script setup lang="ts">
import { ref, computed, useAttrs } from "vue";
import WirisRichText from "@plugins/richtext/components/WirisRichText.vue";
import RichTextEditor from "@plugins/richtext/components/RichTextEditor.vue";

withDefaults(
  defineProps<{
    initialContent?: string;
  }>(),
  {
    initialContent: "",
  },
);

const attrs = useAttrs();

const emit = defineEmits<(e: "ready", id: string) => void>();

const isFocus = ref(false);
const editorId = ref("");
const inputListeners = computed(() => ({
  ready: (id: string) => {
    editorId.value = id;
    emit("ready", id);
  },
}));

function handleFocus() {
  isFocus.value = true;
}
</script>
